module.exports = __webpack_public_path__ + "img/page1.e9d6250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tax/page1.png
// module id = S4Pl
// module chunks = 0